// External Imports
import { Button, IconClose, pxToRem, styled } from '@lessonnine/design-system.lib';
import { h } from 'preact';
import tokens from '@lessonnine/design-tokens.lib/dist/json/variables.json';

// Local Variables
const BackgroundOverlay = styled.div`
  background-color: rgb(12 46 68 / 90%);
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 10;
`;

const IframeContainer = styled.div`
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  gap: ${pxToRem(parseInt(tokens.space.x4, 10))};
  height: 100%;
  justify-content: center;
  margin: auto;

  @media (min-width: ${pxToRem(parseInt(tokens.viewports.breakpoints.xsmall, 10))}) {
    max-width: min(calc(100% - ${pxToRem(parseInt(tokens.space.x32, 10))}), ${pxToRem(1000)});
  }
`;

const IframeForVideo = styled.iframe`
  aspect-ratio: 16 / 9;
  width: 100%;
`;

// Component Definition
function EmbeddedVideo({ buttonLabel, link, setEmbedState, title }) {
  const closeIframe = (event) => {
    if (event.type === 'click' || (event.type === 'keydown' && event.key === 'Escape')) {
      setEmbedState(false);
    }
  };

  return (
    <BackgroundOverlay onClick={closeIframe} onKeyDown={closeIframe}>
      <IframeContainer>
        <Button alignIcon="end" color="secondary-default" icon={<IconClose />}>
          {buttonLabel}
        </Button>
        <IframeForVideo
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          frameBorder="0"
          src={link}
          title={title}
        />
      </IframeContainer>
    </BackgroundOverlay>
  );
}

export { EmbeddedVideo };
